jQuery(function ($) {
    
    $('.js-colvari-btn._active').each(function(){
        var taget = $(this).parents('.js-colvari');
        var tagetImg = $(this).data('colvari');
        $(taget).find(tagetImg).fadeIn(200);
    });
    
    $('.js-colvari-btn').click(function () {
        var taget = $(this).parents('.js-colvari');
        var tagetImg = $(this).data('colvari');
        $(taget).find('.js-colvari-btn').removeClass('_active');
        $(taget).find('.adt-magical--product--item--img-block img').fadeOut(200);
        $(this).addClass('_active');
        setTimeout(function(){
            $(taget).find(tagetImg).fadeIn(200);
        },201);
    });
    
});
